import { useMemo } from 'react';
import { ClbModal } from '@celebration/react/ClbModal/ClbModal';
import { useTranslation } from 'react-i18next';
import IDeleteModalConfirmationProps from './interfaces/IDeleteModalConfirmationProps';

function DeleteModalConfirmation({
    opened,
    isProcessingDeletion,
    carriersToDelete,
    closeModalCallback,
    deleteConfirmedCallback,
}: Readonly<IDeleteModalConfirmationProps>) {
    const { t } = useTranslation();

    const modalTitle = useMemo(() => {
        if (carriersToDelete.length === 1) {
            const carrierName = carriersToDelete[0].tradeName;
            return `${t('Excluir')} "${carrierName}"?`;
        }
        return t('TransportadorasExcluir');
    }, [carriersToDelete, t]);

    const modalContent = useMemo(() => {
        const variableContent =
            carriersToDelete.length === 1
                ? t('OpcaoTransportadoraCNPJ')
                : t('OpcaoTransportadorasCNPJ');

        return (
            <span>
                {`${t('ConfirmarExclusaoTransportadora1')} `}
                <b>
                    {`${variableContent} ${t('ConfirmarExclusaoTransportadora2')} `}
                </b>
                {`${t('ExclusaoAfetaUsuario')} `}
                {carriersToDelete.length === 1
                    ? `${t('ApagarTransportadora')}?`
                    : `${t('ApagarTransportadoras')}?`}
            </span>
        );
    }, [carriersToDelete, t]);

    const deleteConfirmationButtonText = useMemo(() => {
        return carriersToDelete.length === 1
            ? t('ApagarTransportadora')
            : t('ApagarTransportadoras');
    }, [carriersToDelete, t]);

    return (
        <ClbModal
            title={modalTitle}
            open={opened && carriersToDelete.length > 0}
            onClose={closeModalCallback}
            type="danger"
            data-testid="carrier-delete-confirmation"
            customBody={() => modalContent}
            itemsFooter={[
                {
                    key: 'delete-button',
                    id: 'delete-button',
                    label: deleteConfirmationButtonText,
                    title: deleteConfirmationButtonText,
                    loading: isProcessingDeletion,
                    disabled: isProcessingDeletion,
                    'data-testid': 'modal-delete-button',
                    onClick: () => deleteConfirmedCallback(),
                    role: 'button',
                    size: 'md',
                    styleType: 'danger',
                },
                {
                    key: 'cancel-button',
                    id: 'cancel-button',
                    label: t('Cancelar'),
                    title: t('Cancelar'),
                    loading: isProcessingDeletion,
                    disabled: isProcessingDeletion,
                    'data-testid': 'modal-cancel-button',
                    onClick: () => closeModalCallback(),
                    role: 'button',
                    size: 'md',
                    styleType: 'secondary',
                },
            ]}
        />
    );
}

export default DeleteModalConfirmation;
